export { default as ImportDatasetPopup } from './ImportDatasetPopup.vue';
export { default as QueryEditor } from './QueryEditor.vue';
export { default as DremioPanel } from './DremioPanel.vue';
export { default as DremioMultiPanel } from './DremioMultiPanel.vue';

export const DremioMultiPanelAsync = () => import('./DremioMultiPanel.vue');
export const DremioPanelAsync = () => import('./DremioPanel.vue');
